<form class="example-form">
    <mat-form-field class="example-full-width" >
      <mat-label translate>autocomplete.name.operator</mat-label>
      <input  #genInput
              matInput 
              [matAutocomplete]="auto"
              [formControl] =   "myControl" 
              (focus)       =   "focused($event)"
              (click)       =   "genTrigger.openPanel()">
      <mat-autocomplete #auto="matAutocomplete" [displayWith]="displayFn" (optionSelected) = "isChange($event)">
        <mat-option *ngFor="let option of filteredOptions | async" [value]="option">
          {{option.loginName}} - {{option.authorization}}
        </mat-option>
      </mat-autocomplete>
    </mat-form-field>
</form>